import React from 'react';

import { ContainerTable, IContainerTable } from './styles';

const Table: React.FC<IContainerTable> = ({ children, ...rest }) => {
  return <ContainerTable {...rest}>{children}</ContainerTable>;
};

export default Table;
